import { useCallback } from "react";
import { Image } from "@mantine/core";
import { REPORT_IMAGE_ROLE } from "../../utils/reportImageAssets";
import type { ReportPhotoLayout } from "./ReportPhotoContent";

interface ReportPhotoImageProps {
  alt: string;
  imageId: string;
  layout: ReportPhotoLayout;
  onLoadError?: (imageId: string) => void;
  url: string;
}

export function ReportPhotoImage(props: ReportPhotoImageProps) {
  const { alt, imageId, layout, onLoadError, url } = props;
  const handleLoadError = useCallback(
    () => onLoadError?.(imageId),
    [imageId, onLoadError]
  );
  return (
    <Image
      src={url}
      alt={alt}
      data-report-image-role={REPORT_IMAGE_ROLE.clinicalPhoto}
      fit="contain"
      h={layout.height}
      mah={layout.maxHeight}
      maw={layout.maxWidth}
      w={layout.width}
      style={{ objectPosition: layout.objectPosition }}
      onError={handleLoadError}
    />
  );
}
